import { IPublicEnumDragObjectType } from '@alilc/lowcode-types';
export function isDragNodeObject(obj) {
  return obj && obj.type === IPublicEnumDragObjectType.Node;
}